import React from 'react';
import { VISITOR_ROUTES } from '../../../navigation/routeNames';
import ScreenLayout from '../../../shared/components/ScreenLayout';
import VisitorRouteLoadingFallback from '../../../shared/components/VisitorRouteLoadingFallback';
import usePublicAppSettings from '../../../shared/hooks/usePublicAppSettings';
import VisitorBottomSwitchBar from './VisitorBottomSwitchBar';
import VisitorHomeBackButton from './VisitorHomeBackButton';
import VisitorPreparingNotice from './VisitorPreparingNotice';

/** 直接URL・交換QR・地図上の企画導線も同じ表示設定で制御する。履歴は引き続き参照可能。 */
const FEATURE_ROUTES = {
  [VISITOR_ROUTES.SURVEYS]: { key: 'surveysPreparing', label: 'アンケート' },
  [VISITOR_ROUTES.REWARDS]: { key: 'rewardsPreparing', label: '景品' },
  [VISITOR_ROUTES.REDEEM_QR]: { key: 'rewardsPreparing', label: '景品' },
  [VISITOR_ROUTES.EVENTS]: { key: 'eventsPreparing', label: '島（企画）' },
  [VISITOR_ROUTES.CAMPUS_MAP]: { key: 'eventsPreparing', label: '島（企画）' },
} as const;

/**
 * 準備中は対象画面をmountせず、開いている画面も最新設定へ追従させる。
 * @param props ルートと画面
 * @returns 通常画面または準備中案内
 */
const VisitorFeatureGate = ({ routeName, navigation, children }: {
  routeName: string;
  navigation: { navigate: (routeName: string) => void };
  children: React.ReactNode;
}): React.JSX.Element => {
  const { settings, isLoading, hasError, hasLoaded } = usePublicAppSettings();
  const feature = FEATURE_ROUTES[routeName as keyof typeof FEATURE_ROUTES];
  if (!feature) return <>{children}</>;
  if (isLoading) return <VisitorRouteLoadingFallback />;
  // 一度取得できていれば、再取得の一時失敗では最後の確定値で表示を続け、開いている画面のカートやQRを消さない。
  const isVisibilityUnknown = hasError && !hasLoaded;
  if (!settings.homeFeatureVisibility[feature.key] && !isVisibilityUnknown) return <>{children}</>;
  return (
    <ScreenLayout title={feature.label} description="公開状況のご案内" theme="visitor"
      headerLeftAction={<VisitorHomeBackButton onPress={() => navigation.navigate(VISITOR_ROUTES.HOME)} />}
      bottomBar={<VisitorBottomSwitchBar navigation={navigation} activeRouteName={routeName} />}>
      {isVisibilityUnknown && !settings.homeFeatureVisibility[feature.key]
        ? <p role="alert" className="p-5 text-app-text">公開状況を確認できませんでした。通信を確認してから画面を開き直してください。</p>
        : <VisitorPreparingNotice label={feature.label} />}
    </ScreenLayout>
  );
};

export default VisitorFeatureGate;
